import React from "react";

import { FRONT_URL } from "lib/config";

// Brand mark: a cyan diamond carrying a white "play" (same as the frontpage).
export function Mark({ size = 32 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
      <rect x="4.7" y="4.7" width="22.6" height="22.6" rx="4" transform="rotate(45 16 16)" fill="#00A8FF" />
      <path d="M13 11.2c0-.8.9-1.3 1.6-.9l6.6 4.2c.6.4.6 1.3 0 1.7l-6.6 4.2c-.7.4-1.6-.1-1.6-.9z" fill="#FFFFFF" />
    </svg>
  );
}

// Mark + "youwdin class" wordmark, linking to the public site. The text
// span gets `${className}-text`.
export default function Logo({ size = 30, className = "yc-logo" }) {
  return (
    <a href={FRONT_URL} className={className} aria-label="Youwdin Class home">
      <Mark size={size} />
      <span className={`${className}-text`}>
        <small>youwdin</small>
        <b>class</b>
      </span>
    </a>
  );
}
